module.exports = __webpack_public_path__ + "static/media/icon_mobile.e747b8d8.svg";